import { useMutation, useQuery } from '@apollo/client';
import { ReactComponent as SearchIcon } from 'assets/svg/search.svg';
import { StandardAlert } from 'component/StandardAlert';
import StandardPopup from 'component/StandardPopup';
import FeedContainer from 'component/feed_slider/feed_slider';
import CustomLayout from 'component/layout/custom_layout';
import LoadingDataSpinner from 'component/loading_spinner/loading_data_spinner';
import { WidgetCode } from 'component/popup/constant';
import WidgetPopup from 'component/popup/customize_popup';
import ZoomImage from 'component/zoom_image';
import { cache } from 'graph_ql';
import { USER_DETAIL } from 'graph_ql/authentication/queries';
import { SEARCH_STYLE, SEARCH_STYLE_TYPE } from 'graph_ql/search/search_style';
import { useQueryData } from 'hooks/useQuery';
import { capitalize, isEmpty, isNull, union } from 'lodash';
import queryString from 'query-string';
import { useEffect, useMemo, useRef, useState } from 'react';
import { use100vh } from 'react-div-100vh';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
    ESortType,
    changeMaxPrice,
    changeMinPrice,
    changeSortType,
    changeTriggerUpdateSearch,
    setBodyShapeFilter,
    setBodyTypeFilter,
    setCategoryFilter,
    setGenderFilter,
    setIsCategoryDefault,
    setPurposeFilter,
    setSearchTerm,
    setSearchTermChanged,
    setShowFilter,
    setStyleMinMaxPrice,
    setBrandsFilter,
} from 'redux/filter/filterSlice';
import { RootState, useAppSelector } from 'redux/store';
import { getListstyle } from 'redux/style';
import { PATH } from 'routes/constant';
import SwiperCore from 'swiper';
import { buildFilter, buildStoreFilter, generateItemUrlWithAffiliateCode } from 'utils/getQuerySearchStyles';
import { getConsultStylistWAMessage, openWhatsapp } from 'utils/handleSendMessageWhatsapp';
import styleItemUtils from 'utils/style_item';
import utils, { getViewStyleNotificationParams } from 'utils/utils';
import noStyleIcon from '../../assets/svg/no_style_v2.svg';
import config from '../../config';
import { STRINGS, ToastType } from '../../constants';
import {
    PRODUCT_TYPE,
    STYLIST_CONNECT_PROMPT_ACTION,
    TRACK_EVENT,
    WHATSAPP_REASON_TYPE,
    trackEvent,
} from '../../utils/analytics';
import { checkIsPersonalizedStyle, getProductTrackingData } from '../../utils/trackUtils';
import { ALL_BODY_SHAPES, ALL_BODY_TYPES } from './constant';
import './promptStylistConnectPopup.scss';
import { useStyles } from './style';
import { CREATE_NOTIFICATION } from 'graph_ql/notification/mutation';
import { setNotifiedStylesId } from 'redux/authentication/user_detail';
import { useAuthorize } from 'hooks/useAuthorize';
import { useUrlQuery } from 'hooks/useUrlQuery';
import subDays from 'date-fns/subDays';
import startOfToday from 'date-fns/startOfToday';
import getUnixTime from 'date-fns/getUnixTime';

const StyledSearchIcon = () => <SearchIcon style={{ width: 64, height: 64, marginTop: 45 }} />;

interface IQueryParamProps {
    search?: string;
    bodyShape?: string;
    bodyType?: string;
    category?: string;
    gender?: string;
    priceMax?: string;
    priceMin?: string;
    sortBy?: ESortType;
    brand?: string;
}

enum Efilters {
    GENDER = 'gender',
    BODY_SHAPE = 'bodyShape',
    BODY_TYPE = 'bodyType',
    CATEGORY = 'category',
    SORT_BY = 'sortBy',
    PRICE_MIN = 'priceMin',
    PRICE_MAX = 'priceMax',
    BRAND = 'brand',
}
export interface IFeedProps {
    isSearch?: boolean;
    searchKey?: string;
    stylistName?: string;
    title?: string;
    query?: string;
    entityActiveId?: string;
    sourceProductUrl?: string | null;
}
const Feed: React.FC<IFeedProps> = ({
    isSearch = false,
    searchKey,
    stylistName,
    title = '',
    query = '',
    entityActiveId = '',
    sourceProductUrl = null,
}) => {
    const [viewStyleCounter, setViewStyleCounter] = useState(0);
    const [modalShow, setModalShow] = useState({
        show: false,
        title: '',
        content: '',
        button1: '',
        button2: '',
        path: '',
        type: '',
        closeButton: true,
        onFirstButtonClick: () => {},
        onSecondButtonClick: () => {},
        Icon: StyledSearchIcon,
        dialogContentClassName: 'promptConnectStylistDialog',
    });
    const [searchInput, setSearchInput] = useState<String>(searchKey || '');
    const authorize = useAuthorize();
    const user: any = useQueryData(USER_DETAIL, null, authorize?.isAuthorize, true);
    const height: any = use100vh();
    const classes = useStyles();
    const dispatch = useDispatch();
    const [showPopup, setShowPopup] = useState(false);
    const [showPopupInfo, setShowPopupInfo] = useState(false);
    const [listItem, setListItem] = useState<any[]>([]);
    const [heightContent, setHeightContent] = useState<any>();
    const [isShort, setIsShort] = useState(false);
    const [showImage, setShowImage] = useState(false);
    const [img, setImg] = useState<any>('');
    const me = useSelector((state: RootState) => state.userDetail.me);
    const notifiedStylesId = useSelector((state: RootState) => state.userDetail.notifiedStylesId);
    const userDetail = useMemo(() => user?.dataQuery?.me, [user]);
    const currentUserId = userDetail?.id || me?.id;
    const [screenLoading, setScreenLoading] = useState(false);
    const {
        currentSortType,
        currentMinPrice,
        currentMaxPrice,
        genderFilterList,
        categoryFilterList,
        bodyShapeFilterList,
        bodyTypeFilterList,
        triggerUpdateSearch,
        styleMinPrice,
        styleMaxPrice,
        searchTerm,
        showFilter,
        purposeDefault,
        isShowCategoryDefault,
        brandFilterList,
    } = useAppSelector((state: RootState) => state.filter);
    const listStyleLiked = useSelector((state: RootState) => state.userDetail.listStyleLiked);
    const bodyShapeDefault = useSelector((state: RootState) => state.userDetail.bodyShapeDefault);
    const bodyTypeDefault = useSelector((state: RootState) => state.userDetail.bodyTypeDefault);
    const personaDefault = useSelector((state: RootState) => state.userDetail.personaDefault);
    const history = useHistory();
    const [listStyle, setListStyle] = useState([]);
    const [genderValues, setGenderValues] = useState<any>([]);
    const [categoryValues, setCategoryValues] = useState<any>([]);
    const [bodyShapeValues, setBodyShapeValues] = useState<any>([]);
    const [bodyTypeValues, setBodyTypeValues] = useState<any>([]);
    const [brandValues, setBrandValues] = useState<string[]>([]);
    const [currentPage, setCurrentPage] = useState<any>(0);
    const [totalPage, setTotalPage] = useState<any>(0);
    const location = useLocation();
    let queryParams = queryString.parse(location.search);
    const { search, ...restQueryParams }: IQueryParamProps = queryParams;
    const firstLoadRef = useRef(isEmpty(restQueryParams));
    const store = useSelector((state: RootState) => state.widget.store);
    const userGender = (userDetail?.gender || me?.gender || '')
        .toLowerCase()
        .replace('female', 'woman')
        .replace('male', 'man')
        .trim();
    //eslint-disable-next-line
    const searchQuery = useUrlQuery();
    const widgetEntityActiveId = searchQuery.get('taffiId');
    console.log(location.pathname);
    useQuery(SEARCH_STYLE, {
        variables: {
            __typename: SEARCH_STYLE_TYPE.algolia_styles,
            index: config.algolia.algolia_prefix + 'styles',
            query: '',
            filters: 'status:private OR status:unlisted OR status:published',
            hit: config.algoliaHitPerPage,
            page: 0,
            facets: [
                'price',
                'genders.value',
                'categories.name',
                'bodyShapes.title',
                'bodyTypes.title',
                'purposes.title',
                '_consumersIdAndStatus',
                'items.data.brand.name',
            ],
        },
        onCompleted(response) {
            const { facets } = response.locationsInRadius;
            for (const facet of facets) {
                if (facet.name === 'price') {
                    const { min, max } = facet.stats;
                    if (!styleMinPrice && !styleMaxPrice) {
                        dispatch(setStyleMinMaxPrice({ min, max }));
                    }
                }
            }
        },
        fetchPolicy: 'cache-first',
    });

    useEffect(() => {
        if (restQueryParams.sortBy) {
            dispatch(changeSortType(restQueryParams.sortBy));
        }
        if (restQueryParams.priceMin) {
            dispatch(changeMinPrice(Number(restQueryParams.priceMin)));
        }
        if (restQueryParams.priceMax) {
            dispatch(changeMaxPrice(Number(restQueryParams.priceMax)));
        }
        // eslint-disable-next-line
    }, [dispatch]);

    useEffect(() => {
        const genderQueryParamsList = createFilterList({ key: Efilters.GENDER });
        if (genderValues.length || genderQueryParamsList.length) {
            if (genderValues.length) {
                let genderOptions = genderFilterList;
                let queryParams = queryString.parse(location.search);
                const { search, ...rest }: IQueryParamProps = queryParams;
                genderValues.forEach((item) => {
                    let availableOption = false;
                    genderFilterList.forEach((listItem) => {
                        if (listItem.value === item) {
                            availableOption = true;
                        }
                    });
                    if (!availableOption) {
                        let option = {
                            title: item,
                            value: item,
                            isActive: rest.gender
                                ? rest?.gender?.includes(item)
                                : firstLoadRef.current && userGender === item?.toLowerCase(), //to apply the filter from query params.
                            isShow: true,
                        };
                        genderOptions = [...genderOptions, option];
                    }
                });
                dispatch(setGenderFilter(genderOptions));
            } else if (genderQueryParamsList.length) {
                dispatch(setGenderFilter(genderQueryParamsList));
            }
        }
        // eslint-disable-next-line
    }, [genderValues]);
    useEffect(() => {
        const categoryQueryParamsList = createFilterList({ key: Efilters.CATEGORY });
        if (categoryValues.length || categoryQueryParamsList.length) {
            if (categoryValues.length) {
                let categoryOptions = categoryFilterList;
                let queryParams = queryString.parse(location.search);
                const { search, ...rest }: IQueryParamProps = queryParams;
                categoryValues.forEach((item) => {
                    let availableOption = false;
                    categoryFilterList.forEach((listItem) => {
                        if (listItem.value === item) {
                            availableOption = true;
                        }
                    });
                    const styleLike = listStyleLiked?.find(
                        (style) => style?.value?.toLowerCase() === item?.toLowerCase(),
                    );
                    if (!availableOption) {
                        let option = {
                            title: utils.capitalizeString(item),
                            value: item,
                            isActive: rest.category
                                ? rest?.category?.includes(item)
                                : firstLoadRef.current && styleLike?.isActive
                                    ? styleLike?.isActive
                                    : false, //to apply the filter from query params.
                            isShow: true,
                        };
                        categoryOptions = [...categoryOptions, option];
                    }
                });
                dispatch(setCategoryFilter(categoryOptions));
            } else if (categoryQueryParamsList.length) {
                dispatch(setCategoryFilter(categoryQueryParamsList));
            }
        }
        // eslint-disable-next-line
    }, [categoryValues, listStyleLiked, isShowCategoryDefault]);

    useEffect(() => {
        const brandQueryParamsList = createFilterList({ key: Efilters.BRAND });
        if (brandValues.length || brandQueryParamsList.length) {
            if (brandValues.length) {
                let brandOptions = brandFilterList;
                let queryParams = queryString.parse(location.search);
                const { search, ...rest }: IQueryParamProps = queryParams;
                brandValues.forEach((item) => {
                    let availableOption = false;
                    brandFilterList.forEach((listItem) => {
                        if (listItem.value === item) {
                            availableOption = true;
                        }
                    });
                    if (!availableOption) {
                        let option = {
                            title: utils.capitalizeString(item),
                            value: item,
                            isActive: rest.brand ? rest?.brand?.includes(item) : false,
                            isShow: true,
                        };
                        brandOptions = [...brandOptions, option];
                    }
                });
                dispatch(setBrandsFilter(brandOptions));
            } else if (brandQueryParamsList.length) {
                dispatch(setBrandsFilter(brandQueryParamsList));
            }
        }
        // eslint-disable-next-line
    }, [brandValues, listStyleLiked]);
    useEffect(() => {
        const bodyShapeQueryParamsList = createFilterList({ key: Efilters.BODY_SHAPE });
        if (bodyShapeValues?.length || bodyShapeQueryParamsList.length > 0) {
            if (bodyShapeValues?.length > 0) {
                let bodyShapeOptions = bodyShapeFilterList;
                let queryParams = queryString.parse(location.search);
                const { search, ...rest }: IQueryParamProps = queryParams;
                bodyShapeValues
                    ?.filter((item) => item && !item?.toLowerCase().includes(ALL_BODY_SHAPES.toLowerCase()))
                    .forEach((item) => {
                        let availableOption = false;
                        bodyShapeFilterList.forEach((listItem) => {
                            if (listItem.value === item) {
                                availableOption = true;
                            }
                        });
                        if (!availableOption) {
                            let option = {
                                title: item,
                                value: item,
                                isActive: rest.bodyShape
                                    ? rest?.bodyShape?.includes(item)
                                    : firstLoadRef.current &&
                                      item?.toLowerCase() === bodyShapeDefault[0]?.value?.toLowerCase(), //to apply the filter from query params.
                                isShow: true,
                            };
                            bodyShapeOptions = [...bodyShapeOptions, option];
                        }
                    });
                dispatch(setBodyShapeFilter(bodyShapeOptions));
            } else if (bodyShapeQueryParamsList.length) {
                dispatch(setBodyShapeFilter(bodyShapeQueryParamsList));
            }
        }
        // eslint-disable-next-line
    }, [bodyShapeValues, bodyShapeDefault, isShowCategoryDefault]);
    useEffect(() => {
        const bodyTypeQueryParamsList = createFilterList({ key: Efilters.BODY_TYPE });

        if (bodyTypeValues.length > 0 || bodyTypeQueryParamsList.length > 0) {
            if (bodyTypeValues?.length > 0) {
                let bodyTypeOptions = bodyTypeFilterList;
                let queryParams = queryString.parse(location.search);
                const { search, ...rest }: IQueryParamProps = queryParams;
                bodyTypeValues
                    ?.filter((item) => item && !item?.toLowerCase().includes(ALL_BODY_TYPES.toLowerCase()))
                    .forEach((item) => {
                        let availableOption = false;
                        bodyTypeFilterList.forEach((listItem) => {
                            if (listItem.value === item) {
                                availableOption = true;
                            }
                        });
                        if (!availableOption) {
                            let option = {
                                title: item,
                                value: item,
                                isActive: rest.bodyType
                                    ? rest?.bodyType?.includes(item)
                                    : firstLoadRef.current &&
                                      item?.toLowerCase() === bodyTypeDefault[0]?.value?.toLowerCase(), //to apply the filter from query params.
                                isShow: true,
                            };
                            bodyTypeOptions = [...bodyTypeOptions, option];
                        }
                    });
                dispatch(setBodyTypeFilter(bodyTypeOptions));
            } else if (bodyTypeQueryParamsList.length) {
                dispatch(setBodyTypeFilter(bodyTypeQueryParamsList));
            }
            if (firstLoadRef.current) {
                firstLoadRef.current = false;
            }
        }
        // eslint-disable-next-line
    }, [bodyTypeValues, isShowCategoryDefault, bodyTypeDefault]);

    useEffect(() => {
        cache.modify({
            fields: {
                locationsInRadius(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
    }, []);

    //this create filter list function creates the filter json based on the query params.
    const createFilterList = ({ key, initialList = [] }: any) => {
        let queryParams = queryString.parse(location.search);
        const { search, ...rest }: IQueryParamProps = queryParams;

        if (Object.keys(rest)?.includes(key) && !triggerUpdateSearch) {
            let filterOptions = rest[key].split(',');
            return filterOptions.map((item) => {
                return {
                    title: item,
                    value: item,
                    isActive: rest[key] ? rest[key].includes(item) : false,
                    isShow: true,
                };
            });
        } else {
            return initialList;
        }
    };

    // this useeffect is to manipulate the query params based on the applied filter. For future filters, need to dependency and include it in filterlist array.
    useEffect(() => {
        if (isSearch) {
            let existingParams = queryString.parse(location.search);
            let params = { ...existingParams };
            let filterLists = [
                { key: Efilters.GENDER, list: genderFilterList, options: genderValues },
                { key: Efilters.BODY_SHAPE, list: bodyShapeFilterList, options: bodyShapeValues },
                { key: Efilters.BODY_TYPE, list: bodyTypeFilterList, options: bodyTypeValues },
                { key: Efilters.CATEGORY, list: categoryFilterList, options: categoryValues },
                { key: Efilters.BRAND, list: brandFilterList, options: brandValues },
            ];
            filterLists.forEach((filter) => {
                if (filter.list.length) {
                    let selectedFilterOption: string[] = [];
                    filter.list.forEach((item) => {
                        if (item.isActive) {
                            selectedFilterOption = [...selectedFilterOption, item.value];
                        }
                    });
                    if (selectedFilterOption.length && filter.options.length) {
                        //filter.option is to check whether the query params not based on the persist redux
                        params = { ...params, [filter.key]: selectedFilterOption.toString() };
                    } else if (location.search.includes(filter.key) && filter.options.length) {
                        delete params[filter.key];
                    }
                } else if (filter.options.length && triggerUpdateSearch) {
                    // to delete the query params while clicking clear filter button
                    delete params[filter.key];
                }
            });
            let extraFilters = [
                { key: Efilters.SORT_BY, value: currentSortType },
                { key: Efilters.PRICE_MIN, value: currentMinPrice },
                { key: Efilters.PRICE_MAX, value: currentMaxPrice },
            ];
            extraFilters.forEach((item) => {
                if (item.key === Efilters.SORT_BY) {
                    if (currentSortType !== ESortType.DATE_ADDED) {
                        params = { ...params, [item.key]: currentSortType.toString() };
                    } else {
                        delete params[item.key];
                    }
                } else {
                    if (item.value) {
                        params = { ...params, [item.key]: item.value };
                    } else {
                        delete params[item.key];
                    }
                }
            });
            history.replace({ ...location, pathname: location.pathname, search: queryString.stringify(params) });
        }
        // eslint-disable-next-line
    }, [
        genderFilterList,
        genderValues,
        bodyShapeFilterList,
        bodyShapeValues,
        bodyTypeFilterList,
        bodyTypeValues,
        categoryFilterList,
        categoryValues,
        currentSortType,
        currentMinPrice,
        currentMaxPrice,
        history,
        location.pathname,
        location.search,
        triggerUpdateSearch,
        brandFilterList,
    ]);

    const searchVariables = useMemo(() => {
        cache.modify({
            fields: {
                locationsInRadius(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        let index = 'styles';

        const filters = buildFilter({
            firstLoadRef,
            isSearch,
            gender: userGender,
            stylistName,
            currentMinPrice: restQueryParams.priceMin ? restQueryParams.priceMin : currentMinPrice,
            currentMaxPrice: restQueryParams.priceMax ? restQueryParams.priceMax : currentMaxPrice,
            genderFilterList: createFilterList({ key: Efilters.GENDER, initialList: genderFilterList }), //to create the json based on the query params.
            categoryFilterList: createFilterList({ key: Efilters.CATEGORY, initialList: categoryFilterList }), //to create the json based on the query params.,
            bodyShapeFilterList: createFilterList({ key: Efilters.BODY_SHAPE, initialList: bodyShapeFilterList }), //to create the json based on the query params.,
            bodyShapeDefault: bodyShapeDefault,
            bodyTypeFilterList: createFilterList({ key: Efilters.BODY_TYPE, initialList: bodyTypeFilterList }), //to create the json based on the query params.,,
            bodyTypeDefault: bodyTypeDefault,
            purposeDefault,
            listCategoriesDefault: listStyleLiked,
            filterStrDefault: `(_consumersIdAndStatus: ${currentUserId} OR _consumersIdAndStatus: published) AND (status:private OR status:unlisted OR status:published)`,
            brandFilterList: createFilterList({ key: Efilters.BRAND, initialList: brandFilterList }),
        });
        return {
            __typename: isSearch ? SEARCH_STYLE_TYPE.algolia_styles : SEARCH_STYLE_TYPE.algolia_styles_recommend,
            index: config.algolia.algolia_prefix + index,
            query: isSearch ? searchKey : query ? query : '',
            filters,
            hit: config.algoliaHitPerPage,
            page: 0,
            facets: [
                'price',
                'genders.value',
                'categories.name',
                'bodyShapes.title',
                'bodyTypes.title',
                'purposes.title',
                '_consumersIdAndStatus',
                'items.data.brand.name',
            ],
        };
        // eslint-disable-next-line
    }, [isSearch, searchKey, stylistName, userGender, triggerUpdateSearch]);

    const recommendedSearchVariables = useMemo(() => {
        cache.modify({
            fields: {
                locationsInRadius(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        let filters = buildFilter({
            categoryFilterList: listStyleLiked,
            gender: userGender,
            filterStrDefault: `_consumersIdAndStatus: published`,
            bodyShapeDefault,
            bodyTypeDefault,
            personaDefault,
            isRecommended: true,
        });
        return {
            __typename: SEARCH_STYLE_TYPE.algolia_styles_recommend,
            index: config.algolia.algolia_prefix + 'styles',
            query: '',
            filters,
            hit: config.algoliaHitPerPage,
            page: 0,
            facets: [
                'price',
                'genders.value',
                'categories.name',
                'bodyShapes.title',
                'bodyTypes.title',
                'purposes.title',
                '_consumersIdAndStatus',
            ],
        };
        // eslint-disable-next-line
    }, [genderFilterList, listStyleLiked]);

    const personalizedSearchVariables = useMemo(() => {
        let filters = `_consumersIdAndStatus: ${currentUserId} AND (status: private OR status: published OR status:unlisted)`;
        if (utils.isAppInWidgetMode()) {
            filters += ` AND (${buildStoreFilter(store)})`;
        }
        return {
            __typename: SEARCH_STYLE_TYPE.algolia_styles_personalized,
            index: config.algolia.algolia_prefix + 'styles',
            query: '',
            filters,
            page: 0,
            facets: ['_consumersIdAndStatus'],
        };
    }, [currentUserId, store]);

    const discoverStyleSearchVariables = useMemo(() => {
        cache.modify({
            fields: {
                locationsInRadius(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        let filters = `status: published`;
        if (utils.isAppInWidgetMode()) {
            filters += ` AND (${buildStoreFilter(store)})`;
        }
        if (userGender) {
            filters += ` AND genders.value: ${userGender}`;
        }
        return {
            __typename: SEARCH_STYLE_TYPE.algolia_styles_discover_styles,
            index: config.algolia.algolia_prefix + 'styles',
            query: '',
            filters,
            page: 0,
            facets: [],
        };
    }, [store, userGender]);

    const styleItRightSearchVariables = useMemo(() => {
        cache.modify({
            fields: {
                locationsInRadius(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        const startTimeRange = subDays(new Date(startOfToday()), store?.daysToGetStyles);
        let filters = `status: published AND createdTimestamp > ${getUnixTime(startTimeRange)}`;
        if (utils.isAppInWidgetMode()) {
            filters += ` AND (${buildStoreFilter(store)})`;
        }
        const urlWithAffiliateCode = generateItemUrlWithAffiliateCode(
            sourceProductUrl || (searchQuery.get('sourceProductUrl') as string),
            store?.affiliateLink,
        );

        return {
            __typename: SEARCH_STYLE_TYPE.algolia_style_it_right,
            index: config.algolia.algolia_prefix + 'styles',
            query: `"${urlWithAffiliateCode}"`,
            filters,
            page: 0,
            facets: [],
            typoTolerance: false,
            advancedSyntax: true,
        };
    }, [searchQuery, sourceProductUrl, store]);

    const onGetDataStyleComplete = (response, fetch) => {
        const { facets, hits, nbHits, page, nbPages } = response.locationsInRadius;
        setCurrentPage(page);
        if (fetch) {
            dispatch(getListstyle([...(listStyle || []), ...(hits || [])]));
            setListStyle((prev) => [...(prev || []), ...(hits || [])] as any);
        } else {
            dispatch(getListstyle(hits));
            setListStyle(hits);
        }
        if (searchKey !== searchTerm) {
            dispatch(setSearchTerm(searchKey));
            dispatch(setSearchTermChanged(true));
        }
        if (page === 0) {
            setTotalPage(nbPages);
            if (searchKey !== searchTerm || !isEmpty(restQueryParams)) {
                // dispatch(resetFilter())
                dispatch(setShowFilter(true));
                dispatch(setSearchTerm(searchKey));
                dispatch(setSearchTermChanged(true));
                if (nbHits === 0) {
                    setGenderValues([capitalize(userGender)]);
                    setCategoryValues(listStyleLiked?.map((item) => capitalize(item?.value)) || ['']);
                    setBodyShapeValues([capitalize(bodyShapeDefault[0]?.value || '')]);
                    setBodyTypeValues([capitalize(bodyTypeDefault[0]?.value || '')]);
                }
            } else {
                dispatch(setSearchTermChanged(false));
            }
            if (purposeDefault && nbHits === 0) {
                setGenderValues([capitalize(userGender)]);
                setCategoryValues(listStyleLiked?.map((item) => capitalize(item?.value)) || ['']);
                setBodyShapeValues([capitalize(bodyShapeDefault[0]?.value || '')]);
                setBodyTypeValues([capitalize(bodyTypeDefault[0]?.value || '')]);
            }

            if (isSearch) {
                dispatch(changeTriggerUpdateSearch(false));
            }
            if (nbHits > 0) {
                for (const facet of facets) {
                    if (facet.name === 'genders.value') {
                        setGenderValues(Object.keys(facet.data));
                    }
                    if (facet.name === 'categories.name') {
                        //added default values to maintained the default filter if facet not having the values
                        let categoryFacets = Object.keys(facet.data);
                        let defaultCatergories = listStyleLiked?.map((item) => capitalize(item?.value));
                        categoryFacets = union(defaultCatergories, categoryFacets);
                        setCategoryValues(categoryFacets.filter((it) => it != null));
                    }
                    if (facet.name === 'bodyShapes.title') {
                        //added default values to maintained the default filter if facet not having the values
                        let bodyShapeFacets = Object.keys(facet.data);
                        if (
                            bodyShapeFacets.includes(ALL_BODY_SHAPES) &&
                            !bodyShapeFacets.includes(bodyShapeDefault[0]?.value)
                        ) {
                            bodyShapeFacets = [...bodyShapeFacets, bodyShapeDefault[0]?.value];
                        }
                        setBodyShapeValues(bodyShapeFacets.filter((it) => it != null));
                    }
                    if (facet.name === 'bodyTypes.title') {
                        //added default values to maintained the default filter if facet not having the values
                        let bodyTypeFacets = Object.keys(facet.data);
                        if (
                            bodyTypeFacets.includes(ALL_BODY_TYPES) &&
                            !bodyTypeFacets.includes(bodyTypeDefault[0]?.value)
                        ) {
                            bodyTypeFacets = [...bodyTypeFacets, bodyTypeDefault[0]?.value];
                        }
                        setBodyTypeValues(bodyTypeFacets.filter((it) => it != null));
                    }
                    if (facet.name === 'items.data.brand.name') {
                        setBrandValues(Object.keys(facet.data));
                    }
                }
            }

            let params: any;
            let event;
            if (!isSearch) {
                if (location.pathname === PATH.PERSONALIZED_STYLES) {
                    event = TRACK_EVENT.PRODUCT_PERSONALIZED;
                    params = {
                        numOfPersonalizedStyles: nbHits,
                    };
                } else {
                    event = TRACK_EVENT.PRODUCT_RECOMMENDATION;
                    params = {
                        numOfRecommendations: nbHits,
                    };
                }
            } else {
                event = TRACK_EVENT.PRODUCT_SEARCH;
                params = {
                    searchPhrase: searchKey,
                    numOfMatches: nbHits,
                    currency: 'SAR',
                    minPrice: currentMinPrice,
                    maxPrice: currentMaxPrice,
                    gender: genderFilterList.reduce((activeGenders, item) => {
                        if (item.isActive) {
                            activeGenders.push(item.value);
                        }
                        return activeGenders;
                    }, []),
                    sortBy: currentSortType,
                };
            }
            trackEvent(event, {
                userId: currentUserId,
                userType: userDetail?.userType || me?.userType,
                productType: PRODUCT_TYPE.STYLE,
                ...params,
            });
        }
    };

    const getVariablesByType = () => {
        if (location.pathname.includes(PATH.DISCOVER_YOUR_STYLE)) return discoverStyleSearchVariables;
        if (location.pathname.includes(PATH.STYLE_IT_RIGHT)) return styleItRightSearchVariables;
        if (location.pathname === PATH.PERSONALIZED_STYLES) return personalizedSearchVariables;
        if (location.pathname.includes(PATH.FEED)) return recommendedSearchVariables;
        return searchVariables;
    };
    const { loading, fetchMore } = useQuery(SEARCH_STYLE, {
        variables: getVariablesByType(),
        onCompleted(response) {
            onGetDataStyleComplete(response, false);
        },
        skip: isNull(searchVariables),
        fetchPolicy: 'cache-first',
    });

    const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if ((e.target && e.target.value !== searchKey) || (e.suggestion && e.suggestion !== searchKey)) {
                dispatch(setShowFilter(true));
                dispatch(setSearchTerm(searchKey));
                dispatch(setPurposeFilter(null));
                dispatch(setIsCategoryDefault(false));
            }

            history.push({
                pathname: PATH.SEARCH_STYLES,
                search: `?search=${e.suggestion || searchInput}`,
            });
        }
    };
    useEffect(() => {
        const heightMain: any = document.getElementById('main')?.offsetHeight;
        if (heightMain && showFilter) {
            setHeightContent(heightMain);
        } else if (heightMain) {
            setHeightContent(heightMain);
        }
    }, [height, showFilter]);
    const handleViewDetail = (item: any[]) => {
        setShowPopup(true);
        const items = styleItemUtils.mapItemDataWithPrimaryImages(item);
        setListItem(items);
        if (item.length > 1) {
            setIsShort(false);
        } else {
            setIsShort(true);
        }
    };

    const handleAddToBag = async (items) => {
        if (screenLoading) return;
        try {
            setScreenLoading(true);
            if ((swiperInstance?.activeIndex || 0) < 5) {
                // set counter value greater than 5 so we don't show dialog anymore
                setViewStyleCounter(6);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setScreenLoading(false);
        }
    };

    const handleClick = (image) => {
        setImg(image);
        setShowImage(true);
    };
    const [styleInfo, setStyleInfo] = useState<any>();
    const handleViewInfo = (item) => {
        const temp = listStyle?.find((d: any) => d.id === item.id);
        setShowPopupInfo(true);
        setStyleInfo(item?.collection === 'styles' ? temp : item);
    };

    const handleWhatsappStyleOrItem = (item, trackEventParams, user, styleTaffiId) => {
        const msg = getConsultStylistWAMessage({
            userDetail,
            item,
            user,
            styleTaffiId,
        });
        openWhatsapp(msg, {
            ...trackEventParams,
            reason: WHATSAPP_REASON_TYPE.STYLIST_CONSULT_REQUEST,
            stylistId: user.id,
            stylistEmail: user?.email,
            stylistName: user?.firstName + ' ' + user.lastName,
        });
    };

    const handleRedirectToAmira = () => {
        history.push(`${PATH.STYLE_ASSISTANT}`);
    };

    /* eslint-disable react-hooks/exhaustive-deps */
    const handleTrackView = (activeIndex) => {
        const swiperActiveIndex = swiperInstance?.activeIndex || 0;
        if (swiperActiveIndex > viewStyleCounter) {
            setViewStyleCounter(swiperActiveIndex);
        }
        const trackStyleLayoutVersion = true;
        const productViewTrackingData = {
            ...getProductTrackingData(
                userDetail || me,
                listStyle[activeIndex],
                listStyle[activeIndex],
                trackStyleLayoutVersion,
            ),
            personalized: checkIsPersonalizedStyle(listStyle[activeIndex], userDetail || me),
        };
        trackEvent(TRACK_EVENT.PRODUCT_VIEW, productViewTrackingData);
    };

    useEffect(() => {
        if (listStyle.length > 0) {
            handleViewStyleNotification(listStyle[0]);
            if (swiperInstance && currentPage === 0 && !entityActiveId && !widgetEntityActiveId) {
                try {
                    swiperInstance.slideTo(0);
                } catch (e) {}
            }
            handleTrackView(0);
        }
    }, [listStyle]);

    const getStylesSuggestionPopupContent = () => {
        return {
            title: 'Didn’t find what \nyou are looking for ?',
            message: STRINGS.EXPERT_STYLIST_AMIRA,
            button: STRINGS.ASK_AMIRA_NOW,
        };
    };

    useEffect(() => {
        if (viewStyleCounter === 5) {
            const modelContent = getStylesSuggestionPopupContent();
            setModalShow({
                show: true,
                title: modelContent.title,
                content: modelContent.message,
                button1: 'Maybe Later',
                button2: modelContent.button,
                path: '',
                type: ToastType.Error,
                closeButton: true,
                Icon: StyledSearchIcon,
                dialogContentClassName: 'promptConnectStylistDialog',
                onFirstButtonClick: () => {
                    trackEvent(TRACK_EVENT.STYLIST_CONNECT_PROMPT, {
                        userAction: STYLIST_CONNECT_PROMPT_ACTION.MAYBE_LATER,
                        userId: currentUserId,
                        sourcePagePath: location.pathname,
                    });
                },
                onSecondButtonClick: () => {
                    trackEvent(TRACK_EVENT.STYLIST_CONNECT_PROMPT, {
                        userAction: STYLIST_CONNECT_PROMPT_ACTION.ASK_AMIRA_NOW,
                        userId: currentUserId,
                        sourcePagePath: location.pathname,
                    });
                    handleRedirectToAmira();
                },
            });
        }
    }, [viewStyleCounter]);

    const handleClickStylist = (stylist) => {
        history.push(`${PATH.STYLIST_PROFILE}/${stylist?.userName}`);
    };
    const handleExternalChangeSlide = (newSlideIndexToShow) => {
        if (swiperInstance && listStyle.length) {
            swiperInstance.slideTo(newSlideIndexToShow);
        }
    };

    const [createNotificationMutation] = useMutation(CREATE_NOTIFICATION);

    const createNotification = (input: {
        actionObjectId: String;
        actionObjectType: String;
        actor: String;
        message: String;
        recipient: String;
        targetObjectId: String;
        targetObjectType: String;
        verb: String;
        channels: String[];
        channelInfo: any;
    }) => {
        const variables = {
            input,
        };
        createNotificationMutation({ variables });
    };

    const handleViewStyleNotification = (activeStyle) => {
        if (activeStyle?.consumersId?.includes(me?.id) && !notifiedStylesId.includes(activeStyle.id)) {
            dispatch(setNotifiedStylesId([...notifiedStylesId, activeStyle.id]));
            const stylist = activeStyle?.user;
            createNotification(getViewStyleNotificationParams({ me, activeStyle, stylist }));
        }
    };

    const handleChangeSlide = async (e) => {
        const activeStyle = listStyle[e?.activeIndex];
        if (!e.isEnd) {
            handleTrackView(e.activeIndex);
            if (
                e.activeIndex === listStyle.length - config.algoliaPrefetchThreshold &&
                listStyle.length >= config.algoliaHitItems &&
                e.activeIndex > e.previousIndex &&
                currentPage < totalPage - 1 // currentPage index start from 0 so we need to compare with totalPage - 1
            ) {
                const data = await fetchMore({
                    variables: {
                        page: Math.floor(listStyle.length / config.algoliaHitItems),
                        hit: config.algoliaHitItems,
                    },
                });
                onGetDataStyleComplete(data?.data, true);
            }
        }
        if (!isEmpty(activeStyle)) {
            handleViewStyleNotification(activeStyle);
        }
    };
    const handleReturnTitlePage = (isSearch, purposeTitle) => {
        if (purposeTitle && location.pathname.includes(PATH.SEARCH_STYLES)) {
            dispatch(setShowFilter(true));
            return purposeTitle;
        }
        if (title && location.pathname.includes(PATH.HIGHLIGHT)) return title;
        if (!isSearch && location.pathname.includes(PATH.PERSONALIZED_STYLES)) return STRINGS.PERSONALIZED_STYLES;
        if (!isSearch && location.pathname.includes(PATH.DISCOVER_YOUR_STYLE)) return STRINGS.DISCOVER_YOUR_STYLE;
        if (!isSearch && location.pathname.includes(PATH.STYLE_IT_RIGHT)) return STRINGS.STYLE_IT_RIGHT;
        if (!isSearch) return STRINGS.STYLE_RECOMMENDATION;
        return STRINGS.STYLE_SEARCH;
    };

    useEffect(() => {
        if ((entityActiveId || widgetEntityActiveId) && swiperInstance && listStyle) {
            const currentListStyles: any[] = [...listStyle];
            let entityActiveIndex = 0;
            if (
                widgetEntityActiveId &&
                utils.isAppInWidgetMode() &&
                (location.pathname.includes(PATH.DISCOVER_YOUR_STYLE) ||
                    location.pathname.includes(PATH.STYLE_IT_RIGHT))
            ) {
                entityActiveIndex = currentListStyles.findIndex((item) => item?.taffiId === widgetEntityActiveId);
            } else entityActiveIndex = currentListStyles.findIndex((item) => item?.taffiId === entityActiveId);

            if (entityActiveIndex >= 0 && swiperInstance) {
                swiperInstance.slideTo(entityActiveIndex);
            } else {
                swiperInstance.slideTo(0);
            }
        }
    }, [entityActiveId, swiperInstance, listStyle, widgetEntityActiveId]);

    const shouldShowSideBarBtn = useMemo(() => {
        if (!me && location.pathname.includes(PATH.DISCOVER_YOUR_STYLE)) {
            return true;
        }

        return false;
    }, [me]);

    return (
        <>
            {loading && <LoadingDataSpinner isBackground={true} />}
            <CustomLayout
                title={handleReturnTitlePage(isSearch, purposeDefault?.title)}
                showHeaderFilter={!!((isSearch && title) || isSearch)}
                handler={handleKeyDown}
                setInputSearch={setSearchInput}
                showSideBarBtn={shouldShowSideBarBtn}
                value={searchInput}
                style={{ backgroundColor: '#f2f2f2' }}
            >
                <div className={classes.main} id="main">
                    {listStyle && listStyle.length > 0 ? (
                        <FeedContainer
                            handleChangeSlide={handleChangeSlide}
                            handleSendMessageWA={handleWhatsappStyleOrItem}
                            heightContent={heightContent}
                            handleViewDetail={handleViewDetail}
                            handleClick={handleClick}
                            listStyle={listStyle}
                            handleViewInfo={handleViewInfo}
                            handleTrackView={handleTrackView}
                            inputSearch={searchKey}
                            isSearch={isSearch}
                            userDetail={userDetail}
                            handleClickStylist={handleClickStylist}
                            handleExternalChangeSlide={handleExternalChangeSlide}
                            setSwiperInstance={setSwiperInstance}
                            handleLastResult={handleRedirectToAmira}
                        />
                    ) : (
                        !loading && (
                            <div style={{ height: '100%', padding: '30px 24px 0' }}>
                                <StandardAlert
                                    height={`calc( ${heightContent}px - 100px)`}
                                    icon={noStyleIcon}
                                    title={STRINGS.NO_MATCHING_STYLES}
                                    body={
                                        location.pathname === PATH.PERSONALIZED_STYLES
                                            ? `${STRINGS.NO_PERSONALIZED_STYLES} ${STRINGS.ASK_AMIRA_FOR_PERSONALIZED_STYLE}`
                                            : STRINGS.NO_READY_STYLES +
                                              `${
                                                  location.pathname === PATH.SEARCH_STYLES
                                                      ? STRINGS.CLEAR_FILTERS
                                                      : STRINGS.ASK_AMIRA_FOR_PERSONALIZED_STYLE
                                              }`
                                    }
                                    onButtonClick={handleRedirectToAmira}
                                    buttonText={STRINGS.ASK_AMIRA_NOW}
                                    isIcon={false}
                                />
                                {/* ToDo: prompt customer to update style preferences ? or if /recommendations then suggest search ? */}
                            </div>
                        )
                    )}
                </div>
            </CustomLayout>
            {showPopup && (
                <WidgetPopup
                    titlePopup={isShort ? 'Item Details' : 'Style Details'}
                    widgetCode={WidgetCode.ViewDetailStyle}
                    listItem={listItem}
                    setListItem={setListItem}
                    onClose={() => setShowPopup(false)}
                    handleClick={handleAddToBag}
                    isButton={utils.isAppInWidgetMode() || config.removeCheckOut ? false : true}
                    isButtonWhite={false}
                    titleButton={isShort ? 'ADD ITEM TO BAG' : 'ADD ALL ITEMS TO BAG'}
                    shortPopup={isShort}
                    loading={false}
                    styleData={listStyle[swiperInstance?.activeIndex!]}
                />
            )}
            {showPopupInfo && (
                <WidgetPopup
                    titlePopup={styleInfo?.collection === 'styles' ? 'Style Information' : 'Item Information'}
                    widgetCode={WidgetCode.ViewStyleInfo}
                    infoItem={styleItemUtils.getInfo(styleInfo)}
                    onClose={() => setShowPopupInfo(false)}
                    pageCode="feed"
                    infoStyle={listStyle[swiperInstance?.activeIndex!]}
                />
            )}
            {showImage && <ZoomImage img={img} setShowImage={setShowImage} />}
            {modalShow.show && (
                <StandardPopup
                    show={modalShow.show}
                    onHide={() => {
                        setModalShow({ ...modalShow, show: false });
                        console.log('on hiding');
                    }}
                    title={modalShow.title}
                    content={modalShow.content}
                    button1={modalShow.button1}
                    button2={modalShow.button2}
                    type={modalShow.type as any}
                    closeButton={modalShow.closeButton}
                    onFirstButtonClick={modalShow.onFirstButtonClick}
                    onSecondButtonClick={modalShow.onSecondButtonClick}
                    Icon={modalShow.Icon}
                    dialogContentClassName={modalShow.dialogContentClassName}
                />
            )}
        </>
    );
};
Feed.whyDidYouRender = true;
export default Feed;
